import(/* webpackMode: "eager", webpackExports: ["LinkSurvey"] */ "/app/apps/web/modules/survey/link/components/link-survey.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PinScreen"] */ "/app/apps/web/modules/survey/link/components/pin-screen.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/web/modules/survey/link/lib/footerlogo.svg");
;
import(/* webpackMode: "eager", webpackExports: ["Slot"] */ "/app/node_modules/@radix-ui/react-slot/dist/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
